import { useCallback } from 'react';

import AppContent from '@Components/app-layout/Content';
import { useGlobalAuthStore } from '@Stores/global/auth';

import Routes from './Routes';
import Sidebar from './Sidebar';
import { CustomReportProvider } from './views/custom/store';

export default function ReportLayout() {
  const { auth: { menuPermissions } } = useGlobalAuthStore()
  const permission = menuPermissions.map(menu => menu.key);

  const hasPermission = useCallback(mod => permission.includes(mod), [permission])

  return (
    <CustomReportProvider>
      <AppContent>
        <Sidebar hasPermission={hasPermission} />
        <Routes hasPermission={hasPermission} />
      </AppContent>
    </CustomReportProvider>
  )
}
